var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgFill = function SvgBgFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 655,
    height: 509,
    fill: "none",
    viewBox: "0 0 655 509"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 92,
    r: 1,
    fill: "#2A3046"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 102,
    r: 1,
    fill: "#2A3046"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 112,
    r: 1,
    fill: "#2A3046"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 122,
    r: 1,
    fill: "#2A3046"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 132,
    r: 1,
    fill: "#2A3046"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 142,
    r: 1,
    fill: "#2A3046"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 152,
    r: 1,
    fill: "#2A3046"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 162,
    r: 1,
    fill: "#2A3046"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 172,
    r: 1,
    fill: "#2A3046"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 182,
    r: 1,
    fill: "#2A3046"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 134,
    r: 1,
    fill: "#2A3046"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 144,
    r: 1,
    fill: "#2A3046"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 154,
    r: 1,
    fill: "#2A3046"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 164,
    r: 1,
    fill: "#2A3046"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 174,
    r: 1,
    fill: "#2A3046"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 184,
    r: 1,
    fill: "#2A3046"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 194,
    r: 1,
    fill: "#2A3046"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 204,
    r: 1,
    fill: "#2A3046"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 214,
    r: 1,
    fill: "#2A3046"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 224,
    r: 1,
    fill: "#2A3046"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 272,
    r: 2,
    fill: "#2A3046"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 284,
    r: 2,
    fill: "#2A3046"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 296,
    r: 2,
    fill: "#2A3046"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 308,
    r: 2,
    fill: "#2A3046"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 320,
    r: 2,
    fill: "#2A3046"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 332,
    r: 2,
    fill: "#2A3046"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 344,
    r: 2,
    fill: "#2A3046"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 356,
    r: 2,
    fill: "#2A3046"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 368,
    r: 2,
    fill: "#2A3046"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 380,
    r: 2,
    fill: "#2A3046"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m289.54 421.12 74.382 72.016c.056-.886.099-1.758.114-2.628.17-9.107-1.614-18.223-.741-27.285 1.563-16.282 11.695-30.798 24.477-41.004s28.095-16.69 43.331-22.611c28.979-11.268 59.155-21.405 87.505-34.334l90.642-93.619a19.6 19.6 0 0 0-1.981-3.661c-3.995-5.861-11.003-10.294-11.785-17.361-1.204-10.742 12.053-16.559 22.638-18.874 11.86-2.604 23.705-5.194 35.579-7.784l-88.956-86.127c-13.703 4.223-26.635 9.22-37.487 13.436-25.305 9.872-49.483 22.716-71.765 38.282-5.226 3.657-10.476 7.595-13.836 13.006-3.373 5.424-4.47 12.692-1.156 18.114 5.476 8.926 19.995 9.368 24.397 18.861 2.948 6.287-.248 14.068-5.503 18.61-5.255 4.543-12.135 6.627-18.748 8.749-48.218 15.444-94.017 38.35-135.308 67.642-14.412 10.234-29.824 24.868-27.014 42.283 2.047 12.582 13.47 22.728 13.257 35.474-.049 3.162-.791 6.096-2.042 8.815"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D5E0F5",
    d: "M190.082 209.591h-.001l-.6.192c-18.034 5.776-60.274 19.303-97.096 38.209-18.621 9.56-35.823 20.48-47.806 32.444-11.987 11.969-18.676 24.904-16.479 38.525.603 3.701 2.048 7.3 3.784 10.889.833 1.722 1.729 3.434 2.628 5.152l.113.216c.936 1.788 1.872 3.583 2.732 5.388 3.392 7.12 5.65 14.497 2.065 22.608l73.356 71.023c2.451-33.73 18.997-56.769 42.199-74.521 21.909-16.763 49.783-28.832 77.34-40.763q2.853-1.236 5.699-2.471c29.416-12.773 57.967-25.748 78.178-44.503 20.175-18.721 32.046-43.208 28.074-79.081-.833-7.434.645-14.561 2.971-21.367 1.607-4.701 3.632-9.282 5.588-13.706.868-1.965 1.724-3.899 2.522-5.8 2.61-6.209 4.627-12.071 4.7-17.636.072-5.53-1.776-10.796-6.978-15.833l-39.179-37.934c-1.304.4-2.978.898-4.968 1.49-14.701 4.374-46.665 13.885-74.21 26.719-15.782 7.353-30.057 15.772-38.804 24.903-4.37 4.563-7.331 9.273-8.435 14.086-1.1 4.796-.367 9.74 2.735 14.815 3.326 5.422 7.458 10.198 11.212 14.537l.092.106c3.757 4.343 7.162 8.286 8.873 11.962.862 1.849 1.313 3.667 1.147 5.462-.166 1.804-.95 3.533-2.47 5.208-3.014 3.319-8.967 6.468-18.982 9.681Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71 125.724V22.192a56 56 0 0 1 1.968 1.746c6.66 6.213 11.97 13.835 19.087 19.512 12.784 10.202 30.261 13.02 46.485 10.936 16.223-2.084 31.533-8.575 46.385-15.402C213.177 26.002 241.45 11.374 270.459 0h130.31c.556 1.27.974 2.6 1.252 3.97 1.432 6.947-.258 15.066 4.275 20.544 6.88 8.336 20.28 2.858 29.307-3.136 10.12-6.71 20.22-13.418 30.34-20.147v123.818c-12.566 6.907-25.151 12.723-35.729 17.586-24.694 11.314-50.74 19.75-77.422 24.931-6.263 1.21-12.744 2.243-18.968.893-6.243-1.35-12.227-5.617-13.818-11.77-2.604-10.143 7.178-20.882 3.42-30.647-2.466-6.491-10.279-9.608-17.198-8.992s-13.203 4.109-19.326 7.384c-44.636 23.899-92.95 40.869-142.716 50.159-17.378 3.235-38.612 4.128-49.17-10.005-7.614-10.222-6.958-25.486-16.263-34.199-2.306-2.164-4.93-3.672-7.753-4.665"
  }))));
};
export default SvgBgFill;